import { atom } from "recoil";

export const AssetListPageState = atom<number>({
    key: "assetListPageState",
    default: 1
});